import { render, staticRenderFns } from "./VabBoxAreaRightPanel.vue?vue&type=template&id=a26f99e8"
import script from "./VabBoxAreaRightPanel.vue?vue&type=script&lang=js"
export * from "./VabBoxAreaRightPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a26f99e8')) {
      api.createRecord('a26f99e8', component.options)
    } else {
      api.reload('a26f99e8', component.options)
    }
    module.hot.accept("./VabBoxAreaRightPanel.vue?vue&type=template&id=a26f99e8", function () {
      api.rerender('a26f99e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabBoxArea/components/VabBoxAreaRightPanel.vue"
export default component.exports